import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';

interface ProductIngredientsProps {
  ingredients?: string | null;
  isExempt?: boolean | null;
}

export default function ProductIngredients({ ingredients, isExempt }: ProductIngredientsProps): React.JSX.Element {
  const { t } = useTranslation(['products']);

  return (
    <Box>
      <Typography variant="titleSmall" sx={{ mb: 1 }}>
        {t('products:ingredient_list')}
      </Typography>
      <Typography variant="bodySmall">
        {isExempt ? t('products:no_ingredient') : ingredients}
      </Typography>
    </Box>
  );
}
